import { z } from 'zod'
import { apiFetch } from '@shared/api/http'

export const EmailPreferencesSchema = z
  .object({
    salePaid: z.boolean(),
    subscriptionCreated: z.boolean(),
    subscriptionCanceled: z.boolean(),
    subscriptionPaymentFailed: z.boolean(),
    payoutPaid: z.boolean(),
  })
  .strict()

export type EmailPreferences = z.infer<typeof EmailPreferencesSchema>

export async function getEmailPreferences(): Promise<EmailPreferences> {
  return EmailPreferencesSchema.parse(await apiFetch<unknown>('/notifications/email-preferences'))
}

export async function updateEmailPreferences(
  input: Partial<EmailPreferences>,
): Promise<EmailPreferences> {
  const body = EmailPreferencesSchema.partial().parse(input)
  return EmailPreferencesSchema.parse(
    await apiFetch<unknown>('/notifications/email-preferences', {
      method: 'PATCH',
      body,
    }),
  )
}
